import React, { useState, useRef } from "react";
import logo from "../assets/pos.png";
import "../style/login.css";
import API from "../axios";

import { useNavigate } from "react-router-dom";


function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState("");

  const passwordRef = useRef(null);
  const loginBtnRef = useRef(null);

  const navigate = useNavigate();

async function handleLogin() {
  try {
    if (username === "") {
      setErrorMsg("Enter username");
      return;
    }

    if (password === "") {
      setErrorMsg("Enter password");
      return;
    }

    const response = await API.post("/login", {
      username: username,
      password: password,
    });

    const data = response.data;

    console.log("getting : ", data);

    if (data.status === "success") {

      if(password == 1){
        alert("Password was expired, Reset the Password.")        
        navigate("/forgetpassword")
        return;
      }

      localStorage.setItem("empDetails", JSON.stringify(data.data));

      navigate("/Dashboard");

    } else {
      // ✅ SHOW BACKEND MESSAGE
      setErrorMsg(data.message);
    }

  } catch (error) {
    console.error(error);

    // ✅ SHOW SERVER ERROR MESSAGE
    if (error.response) {
      setErrorMsg(error.response.data.message);
    } else {
      console.log("Technical issue")
      setErrorMsg("Try again later.");
    }
  }
}



  return (
    <div className="loginmain d-flex justify-content-center align-items-center vh-100" >
      <div
        className="loginBox  shadow p-lg-5 rounded-2 p-3"
        style={{ marginTop: "-100px" }}
      >
        <div className="logo d-flex justify-content-center">
          <img
            className="logo"
            src={logo}
            alt="Logo"
            style={{ height: "75px", objectFit: "contain" }}
          />
        </div>

        <h4 className="text-center p-lg-3 p-2">Employee Portal</h4>

        <div className="form d-flex flex-column gap-lg-3 my-lg-3 gap-3 my-3">
          <div className="form-group">
            <label className="fw-bold">User ID</label>
            {/* <input type="text" required className="form-control inp" onChange={(e) => setUsername(e.target.value)} 
             onKeyDown={(e) => {
              if (e.key === "Enter") {
                passwordRef.current.focus();
              }
            }}
            /> */}

            <input
              type="text"
              required
              className="form-control inp"
              onChange={(e) => setUsername(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  passwordRef.current?.focus();
                }
              }}
            />

          </div>

          {/* 🔐 Password with eye toggle */}
          <div className="form-group position-relative ">
            <label className="fw-bold">Password</label>

            {/* <input
              type={showPassword ? "text" : "password"}
              required
              className="form-control pe-5 inp"
              onChange={(e) => setPassword(e.target.value)}
               onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleLogin();
                  }
                }}

            /> */}

            <input
              type={showPassword ? "text" : "password"}
              required
              className="form-control pe-5 inp"
              ref={passwordRef}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleLogin();
                }
              }}
            />


            {/* Eye Icon */}
            <i
              className={`bi eyeicon maineye ${
                showPassword ? "bi-eye-slash" : "bi-eye"
              } position-absolute`}
              style={{
                right: "15px",
                top: "30px",
                cursor: "pointer",
                fontSize: "18px",
              }}
              onClick={() => setShowPassword(!showPassword)}
            ></i>
          </div>

            <span
              className="text-primary fw-bold fpwd"
              onClick={() => navigate("/forgetpassword")}
            >
              Forgot Password?
            </span>
          

              {errorMsg && <div className="text-danger error fw-bold text-center">{errorMsg}</div>}
          <div className="form-group w-100 mt-lg-2 mt-2">
            <button className="btn btn-sm btn-warning fw-bold text-center w-100 p-2" onClick={handleLogin} ref={loginBtnRef}>
              Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;